import React from "react";
import { Button, Alert } from "react-bootstrap";
import HeaderLogin from "../HeaderLogin/HeaderLogin.jsx";
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { VpnKey } from "@material-ui/icons";
import { connect } from "react-redux";
import {
  validateResetTokenAction,
  validateResetTokenActionNew,
} from "../../actions/UserActions";
import { toastMessage } from "../Common/Common";
import * as code from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";
const initialValue = {
  password: "",
  confirmPassword: "",
};

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showResetPassword: false,
      token: null,
      passwordSuccess: false,
      changedPasswordSuccess: false,
      LoginMessage: "",
    };
    // console.log("In reset password");
  }

  componentWillMount() {
    //Validate token
    if (this.props.match.params.token) {
      let Token = this.props.match.params.token;
      this.setState({
        showResetPassword: true,
        token: Token,
      });
    }
  }
  goToLogin() {
    this.props.history.push("/login");
  }

  /**
   * @desc call api for validating token for reset password
   * @param {*} vals
   */
  resetUserPassword(vals) {
    vals.password = vals.password.trim();

    if (localStorage.getItem("PS")) {
      this.setState({
        // psemail: localStorage.getItem("email"),
        psUserName: localStorage.getItem("userName"),
        ps: true,
      });
      let apiData = {
        // email: this.state.psemail,
        userName: this.state.psUserName,
        password: vals.password,
      };
      this.props
        .validateResetTokenActionNew(null, apiData, "SETPASS")
        .then((res) => {
          if (res) {
            if (localStorage.getItem("usertype") != "ADMIN") {
              let firstOpen = localStorage.getItem("firstOpen");
              localStorage.clear();
              const currentDate = new Date();
              localStorage.setItem(
                "lastOpenedDate",
                currentDate.toDateString()
              );
              localStorage.setItem("firstOpen", firstOpen);
            } else {
              localStorage.clear();
            }

            if (res.status == code.OK) {
              this.setState({
                changedPasswordSuccess: true,
                showResetPassword: null,
                passwordSuccess: null,
              });
            } else if (
              res.status == code.SERVER_ERROR ||
              res.status == code.BAD_REQUEST
            ) {
              this.setState({
                showResetPassword: true,
              });
              toastMessage(code.ERROR, res.data);
            }
          }
        });
    } else {
      let apiData = {
        password: vals.password,
      };
      this.props
        .validateResetTokenActionNew(this.state.token, apiData)
        .then((res) => {
          if (res) {
            if (res.status == code.OK) {
              this.setState({
                passwordSuccess: true,
                successMessage: "Your password has been updated successfully!",
              });
            } else if (
              res.status == code.SERVER_ERROR ||
              res.status == code.BAD_REQUEST
            ) {
              this.setState({
                showResetPassword: true,
              });
              toastMessage(code.ERROR, res.data);
            }
          }
        });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  render() {
    var accessToken = localStorage.getItem("accessToken");

    return (
      <div>
        <div className="loginBg loginContent align-items-end flex-column">
          <div className="loginBox">
            {this.state.LoginMessage != "" &&
              this.state.LoginMessage !== undefined && (
                <Alert variant="danger">{this.props.LoginMessage}</Alert>
              )}
            {this.state.passwordSuccess ? (
              <>
                <Alert variant="success">{this.state.successMessage}</Alert>

                {!!accessToken ? (
                  <Button
                    variant="link"
                    className="pr-0 font-14 font-500"
                    style={{ color: "#4a90e2" }}
                    onClick={() => {
                      this.props.history.push("/dashboard");
                    }}
                  >
                    {" "}
                    Go to Dashboard
                  </Button>
                ) : (
                  <Button
                    variant="link"
                    className="pr-0 font-14 font-500"
                    style={{ color: "white" }}
                    onClick={() => this.goToLogin()}
                  >
                    {" "}
                    Please click here to login to your account
                  </Button>
                )}
              </>
            ) : (
              ""
            )}
            {this.state.showResetPassword && !this.state.passwordSuccess ? (
              <div>
                <h4>Reset Password</h4>
                <Formik
                  validateOnBlur={true}
                  initialValues={initialValue}
                  enableReinitialize={true}
                  validationSchema={Yup.object().shape({
                    password: Yup.string()
                      .required(message.ENTER_PASSWORD)
                      .min(6, message.PASSWORD_LENGTH)
                      .matches(/^\S*$/, message.ENTER_VALID_PASSWORD),
                    confirmPassword: Yup.string()
                      .when("password", {
                        is: (val) => (val && val.length > 0 ? true : false),
                        then: Yup.string().oneOf(
                          [Yup.ref("password")],
                          message.CONFIRM_PASSWORD_MATCH
                        ),
                      })
                      .required(message.CONFIRM_PASSWORD)
                      .min(6, message.PASSWORD_LENGTH),
                  })}
                  onSubmit={(values, { setSubmitting }) => {
                    this.resetUserPassword(values);
                  }}
                >
                  {({ handleChange, errors, values, touched }) => (
                    <Form>
                      <div className="form-group">
                        <label className="form-label" htmlFor="password">
                          Password
                        </label>
                        <div className="icon-wrapper input-group">
                          <Field
                            type="password"
                            name="password"
                            onChange={handleChange}
                            value={values.password}
                            className={
                              "form-control form-control-lg" +
                              (errors.password && touched.password
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <span className="form-control-icn">
                            <VpnKey />
                          </span>
                          <ErrorMessage
                            name="password"
                            component="div"
                            className="invalid-feedback"
                            style={{ display: "block", color: "white" }}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="confirmPassword">
                          Confirm Password
                        </label>
                        <div className="icon-wrapper input-group">
                          <Field
                            type="password"
                            name="confirmPassword"
                            value={values.confirmPassword}
                            onChange={handleChange}
                            className={
                              "form-control form-control-lg" +
                              (errors.confirmPassword && touched.confirmPassword
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <span className="form-control-icn">
                            <VpnKey />
                          </span>
                          <ErrorMessage
                            name="confirmPassword"
                            component="div"
                            className="invalid-feedback"
                            style={{ display: "block", color: "white" }}
                          />
                        </div>
                      </div>
                      <div className="form-group pt-2">
                        <Button
                          type="submit"
                          variant="primary"
                          size="lg"
                          block
                          className="btn-blue btn-medium"
                        >
                          Submit
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            ) : !this.state.showResetPassword &&
              this.state.showResetPassword != null &&
              !this.state.passwordSuccess &&
              this.state.passwordSuccess != null ? (
              <div className="message-log-before mb-3">
                <h4 className="mb-3">Reset Password</h4>
                <p className="font-14 color-grey-1 font-400">
                  The Token You provided is either INVALID or EXPIRED.
                </p>
              </div>
            ) : this.state.changedPasswordSuccess ? (
              <div className="message-log-before mb-3">
                <h4 className="mb-3">Reset Password</h4>
                <p className="font-14 color-grey-1 font-400">
                  Created Password Successfully.
                </p>
                <Button
                  variant="primary"
                  className="btn-blue btn-medium btn btn-block btn-lg"
                  onClick={() => this.goToLogin()}
                >
                  Login
                </Button>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.reducer.isAuthenticated,
    LoginMessage: state.reducer.LoginMessage,
  };
};

export default connect(
  mapStateToProps,
  { validateResetTokenAction, validateResetTokenActionNew }
)(ResetPassword);
